import { StyleFunctionProps } from "@chakra-ui/react"

const getFilledTrackProps = (size: string) => {
  switch (size) {
    case "xs": {
      return {
        height: "6px",
        top: "-2px",
      }
    }
    case "sm": {
      return {
        height: "12px",
        top: "-4px",
      }
    }
    case "md": {
      return {
        height: "18px",
        top: "-6px",
      }
    }
    case "lg": {
      return {
        height: "24px",
        top: "-8px",
      }
    }
    default: {
      return {
        height: "6px",
        top: "-2px",
      }
    }
  }
}

const getTrackProps = (size: string) => {
  switch (size) {
    case "xs": {
      return {
        height: "2px",
      }
    }
    case "sm": {
      return {
        height: "4px",
      }
    }
    case "md": {
      return {
        height: "6px",
      }
    }
    case "lg": {
      return {
        height: "8px",
      }
    }
    default: {
      return {
        height: "2px",
      }
    }
  }
}

const theme = {
  variants: {
    smallerBackgroundBar: (props: StyleFunctionProps) => ({
      filledTrack: {
        bg: props.colorScheme,
        position: "relative",
        borderRadius: "20px",
        ...getFilledTrackProps(props.size),
      },
      track: {
        bg: props.bg,
        overflow: "visible",
        ...getTrackProps(props.size),
      },
    }),
  },
}

export default theme
